import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { MeterMediaType } from './const/enums';

export class MeterModel extends ModelBase {
  meterType: MeterMediaType;
  name: string;
  manufacturer: string;
  meterTypeCaption: string;
  toString(culture?: string): string {
    return this.name;
  }
}
